import { Box } from '@chakra-ui/react';
import { DayPickerRangeController } from 'react-dates';

import { CaretLeftIcon, CaretRightIcon } from '../icons';

const DayPickerRangeControllerWrapper = (props) => (
  <DayPickerRangeController
    noBorder
    navPrev={
      <Box
        role="button"
        tabIndex="0"
        className="DayPickerNavigation_button DayPickerNavigation_button_1 DayPickerNavigation_button__default DayPickerNavigation_button__default_2 DayPickerNavigation_button__horizontal DayPickerNavigation_button__horizontal_3 DayPickerNavigation_button__horizontalDefault DayPickerNavigation_button__horizontalDefault_4 DayPickerNavigation_leftButton__horizontalDefault DayPickerNavigation_leftButton__horizontalDefault_5"
      >
        <CaretLeftIcon boxSize={4} stroke="primary.500" fill="primary.500" />
      </Box>
    }
    navNext={
      <Box
        role="button"
        tabIndex="0"
        className="DayPickerNavigation_button DayPickerNavigation_button_1 DayPickerNavigation_button__default DayPickerNavigation_button__default_2 DayPickerNavigation_button__horizontal DayPickerNavigation_button__horizontal_3 DayPickerNavigation_button__horizontalDefault DayPickerNavigation_button__horizontalDefault_4 DayPickerNavigation_rightButton__horizontalDefault DayPickerNavigation_rightButton__horizontalDefault_5"
      >
        <CaretRightIcon boxSize={4} stroke="primary.500" fill="primary.500" />
      </Box>
    }
    phrases={{
      chooseAvailableStartDate: ({ date }) => `Choose ${date} as start date`,
      chooseAvailableEndDate: ({ date }) => `Choose ${date} as end date`,
    }}
    {...props}
  />
);

export default DayPickerRangeControllerWrapper;
